<template>
  <div class="icon-eyes">
    <svg v-if="passwordFieldType === 'password'"
         xmlns="http://www.w3.org/2000/svg"
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none">
      <path d="M9.87996 7.97053C9.87996 9.00703 9.03646 9.85053 7.99995 9.85053C6.96345 9.85053
      6.11995 9.00703 6.11995 7.97053C6.11995 6.93403 6.96345 6.09053 7.99995 6.09053C9.03646
      6.09053 9.87996 6.93403 9.87996 7.97053ZM15.9225 8.36453C15.7975 8.56253 12.7995 13.2195
      7.99995 13.2195C3.08845 13.2195 0.193954 8.57053 0.0729538 8.37303C0.00445377 8.26103
      -0.0110462 8.13353 0.0129538 8.01453C-0.0160462 7.88903 0.00295377 7.75303 0.0769538
      7.63503C0.201954 7.43703 3.19995 2.78003 7.99945 2.78003C12.911 2.78003 15.8055 7.42903
      15.9265 7.62653C15.995 7.73853 16.0105 7.86603 15.9865 7.98503C16.0155 8.11103 15.997
      8.24703 15.9225 8.36453ZM10.88 7.97053C10.88 6.38253 9.58795 5.09053 7.99995 5.09053C6.41195
      5.09053 5.11995 6.38253 5.11995 7.97053C5.11995 9.55853 6.41195 10.8505 7.99995 10.8505C9.58795 10.8505
      10.88 9.55853 10.88 7.97053Z" fill="#CDCDCD"/>
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg"
         width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none">
      <path d="M13.0169 1.97744C12.8214 1.78194 12.5054 1.78194 12.3099 1.97744L10.9279
               3.35944C10.0534 3.00744 9.07694 2.78044 7.99994 2.78044C3.20044 2.78044 0.202442
               7.43694 0.0774421
               7.63544C0.00344205 7.75294 -0.015558 7.88944 0.0134421 8.01494C-0.010558 8.13394
               0.00494205 8.26144 0.0734421
               8.37344C0.142942 8.48744 1.13444 10.0679 2.89444 11.3939L1.73294 12.5549C1.53744
               12.7504 1.53744 13.0664 1.73294
               13.2619C1.83044 13.3594 1.95844 13.4084 2.08644 13.4084C2.21444 13.4084 2.34244
               13.3594 2.43994 13.2619L13.0169
               2.68444C13.2119 2.48944 13.2119 2.17294 13.0169 1.97744ZM5.11994 7.97044C5.11994
               6.38244 6.41194 5.09044 7.99994
               5.09044C8.35594 5.09044 8.69594 5.15744 9.01044 5.27644L8.17994 6.10694C8.11994
               6.10044 8.06144 6.09044 7.99994
               6.09044C6.96344 6.09044 6.11994 6.93394 6.11994 7.97044C6.11994 8.03194 6.13044
               8.09044 6.13644 8.15044L5.30594
               8.98094C5.18694 8.66694 5.11994 8.32644 5.11994 7.97044ZM15.9224 8.36444C15.7974
               8.56244 12.7994 13.2194 7.99994
               13.2194C6.74694 13.2194 5.62694 12.9149 4.64944 12.4609L6.61594 10.4939C7.02694
               10.7204 7.49894 10.8499 8.00044
               10.8499C9.58844 10.8499 10.8804 9.55794 10.8804 7.96994C10.8804 7.46844 10.7509
               6.99694 10.5244 6.58544L12.7594
               4.35044C14.7364 5.71944 15.8534 7.50494 15.9269 7.62594C15.9954 7.73794 16.0109
               7.86544 15.9869 7.98444C16.0154
               8.11094 15.9969 8.24694 15.9224 8.36444ZM7.37494 9.73544L9.76494 7.34594C9.83494
               7.54244 9.87994 7.75094 9.87994
               7.97094C9.87994 9.00744 9.03644 9.85093 7.99994 9.85093C7.77994 9.85044
               7.57144 9.80544 7.37494 9.73544Z" fill="#CDCDCD"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconEyes',
  props: ['passwordFieldType']
}
</script>

<style lang="scss">
@import "../../../sass/variables";
@import "../../../sass/mixins";

.icon-eyes {
  svg {
    path {
      opacity: 1;
      transition: .3s linear;
    }
  }

  &:hover {
    svg {
      path {
        fill: $color-malibu;
        opacity: 0.8;
        transition: .3s linear;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/Icons/IconEyes.vue